import React, { FC } from "react";

import { SuggestedBadge } from "@/components/Badge";
import { Text } from "@/components/Text";
import { IRole } from "@/data/roles";

interface ISuggestedRoleBadgeProps {
  role: IRole;
  onClick: () => void;
  onCheckedClick: () => void;
  isChecked?: boolean;
}

export const SuggestedRoleBadge: FC<ISuggestedRoleBadgeProps> = ({
  role,
  onClick,
  onCheckedClick,
  isChecked = false,
}) => {
  return (
    <SuggestedBadge onClick={isChecked ? onCheckedClick : onClick} isChecked={isChecked}>
      <Text size="md">{role.name}</Text>
    </SuggestedBadge>
  );
};
